module.exports = __webpack_public_path__ + "img/4.f7a199e9.gif";